import { useState } from 'react';

import { Icon } from '@/components/common/icon';
import { Link } from '@/components/common/link';
import { TGradientIcon } from '@/shared/types';

interface HomePageScrollIconProps {
  scrollTo?: string;
}

export const HomePageScrollIcon = ({ scrollTo = '' }: HomePageScrollIconProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const iconProps: TGradientIcon = {
    ...(isHovered ? { color: 'text-mantis' } : { gradient: 'juneBudConifer' })
  };

  return (
    <div className="flex justify-center">
      <Link
        classes="pointer-events-auto group flex flex-col items-center gap-2 px-6 py-4 mb-2 sm:mb-4 rounded-md cursor-pointer select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-mantis/40"
        to={`/#${scrollTo}`}
        noUnderline
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <span className="pointer-events-none text-xs font-mono tracking-widest uppercase text-mountain-mist group-hover:text-mantis transition-colors duration-300">
          Scroll
        </span>

        <span className="pointer-events-none">
          <Icon
            classes="animate-leap transition-all ease-out duration-300 [&>svg]:w-10 [&>svg]:h-10 sm:[&>svg]:w-12 sm:[&>svg]:h-12 [&>svg_path]:stroke-2"
            name="chevronDownDouble"
            {...iconProps}
          />
        </span>
      </Link>
    </div>
  );
};
